/*
 * @Author: WangChao
 * @Date: 2025-11-25 22:31:56
 * @LastEditors: WangChao
 * @LastEditTime: 2025-12-31 16:48:25
 * @FilePath: \travel_ai\src\definition\conf\index.js
 * @Description:
 */
export const getConfig = (attr = '') => {
  try {
    let value = process.env.config[attr]
    if (value) {
      return value
    } else {
      console.log(`没找到"${attr}"的配置信息`)
      return ''
    }
  } catch (e) {
    console.log('配置文件读取错误')
    return ''
  }
}

export const logInfo = () => {
  whoami();
  console.log(
    `%c ${getConfig("des")} %c`,
    "background: #EA4949; font-size: 30px; padding: 1px; border-radius: 3px 0 0 3px;  color: #fff",
    "background:#1377eb ; padding: 1px; border-radius: 0 3px 3px 0; font-size: 20px;  color: #fff"
  );
  logVersion();
};
const logVersion = () => {
  console.log(
    `%c ${getConfig("version")} %c`,
    "background: green; font-size: 20px; padding: 1px; border-radius: 3px 0 0 3px;  color: #fff",
    "background:#1377eb ; padding: 1px; border-radius: 0 3px 3px 0; font-size: 20px;  color: #fff"
  );
};
const whoami = () => {
  console.log(
    `%c 元年出品 %c 霄途商旅前端组 %c`,
    "background:#35495e ; font-size: 20px; padding: 1px; border-radius: 3px 0 0 3px;  color: #fff",
    "background:#1377eb ; padding: 1px; border-radius: 0 3px 3px 0; font-size: 20px;  color: #fff",
    "background:transparent"
  );
};
